// @TODO (CHAIR-19856): Remove file after test
import { getAmplitudeExperimentFlagMap } from 'chairisher/context/experiments';
import { isExperimentVariantB } from 'chairisher/thirdparty/experiments';

/**
 * @returns {boolean} Indicates if user is in treatment bucket for PayPal removal AB test.
 */
export function isPaypalRemovalTreatment() {
    return isExperimentVariantB(getAmplitudeExperimentFlagMap().PAYPAL_REMOVAL);
}

/**
 * Toggles the conjunction text on cart drawer payment button options
 *
 * @param {jQuery} $el Element containing the processing fee info.
 */
export function toggleConjunctionText($el) {
    const $walletOptions = $el.find('.js-express-payment-request-button-wrapper');
    if ($walletOptions.length) {
        $el.find('.js-checkout-btn-conjunction').toggleClass('hidden', $walletOptions.hasClass('hidden'));
    }
}

/**
 * Replaces PayPal in processing fee wording with debit card.
 *
 * @param {jQuery} $el Element containing the processing fee info.
 */
export function replacePaypalWithDebitInProcessingFee($el) {
    const $disclaimerEl = $el.find('.js-processing-fee-disclaimer');
    const originalDisclaimer = $disclaimerEl.text();
    $disclaimerEl.text(originalDisclaimer.replace('via PayPal', 'with a debit card'));
    toggleConjunctionText($el);
}
